import { getGroupsArray } from '../../../../stores/groups/groups.selectors'

const changeSortKey = (key, direction) => ({
  type: 'GROUPS_COMPONENT:SET_SORT_KEY',
  key,
  direction
})

const groupAction = id => ({ type: 'GROUPS_COMPONENT:GROUP_ACTION', id })

const setGroupSelectStatus = (id, status) => ({
  type: 'GROUPS_COMPONENT:SET_SELECT_STATUS',
  id,
  status
})

const setGroupSelectStatuses = statuses => ({
  type: 'GROUPS_COMPONENT:SET_SELECT_STATUSES',
  statuses
})

const selectAllGroups = () => (dispatch, getState) => {
  const groups = getGroupsArray(getState())
  const statuses = {}
  groups.forEach(group => (statuses[group.id] = true))
  dispatch(setGroupSelectStatuses(statuses))
}

const showSelectedGroups = () => ({ type: 'GROUPS_COMPONENT:SHOW_SELECTED' })
const unsetShowSelectedGroups = () => ({ type: 'GROUPS_COMPONENT:SHOW_ALL' })

const deselectAllGroups = () => dispatch => dispatch(setGroupSelectStatuses({}))

export {
  changeSortKey,
  setGroupSelectStatus,
  selectAllGroups,
  deselectAllGroups,
  groupAction,
  showSelectedGroups,
  unsetShowSelectedGroups
}
